// @flow
import IconRepo from '../../shared/icons/IconRepo'
import WithBackButton from '../../shared/icons/WithBackButton'

export default WithBackButton(IconRepo)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/Header/BackToRepoListLink.js